export default {
  LOAD_COMPETENCY_CYCLE_LIST_START: 'LoadCompetencyCycleListStart',
  LOAD_COMPETENCY_CYCLE_LIST_END: 'LoadCompetencyCycleListEnd',
  TOGGLE_COMPETENCY_CYCLE_LIST_CONFIRM_DIALOG: 'ToggleCompetencyCycleListConfirmDialog'
};